import { render, staticRenderFns } from "./STransfers.vue?vue&type=template&id=5525c68c&scoped=true"
import script from "./STransfers.vue?vue&type=script&lang=js"
export * from "./STransfers.vue?vue&type=script&lang=js"
import style0 from "./STransfers.vue?vue&type=style&index=0&id=5525c68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525c68c",
  null
  
)

export default component.exports